module.exports = __webpack_public_path__ + "img/menu5.28fc050c.png";